import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-parchment ${className}`} aria-hidden="true" data-id="element-93" data-mp="1zbqyo7zazzuw">
      <Icon className="h-6 w-6 text-gold" strokeWidth={1.4} data-id="element-94" data-mp="249acx7w04cmu" />
    </span>;
}